// eslint-disable-next-line no-unused-vars
import { http } from '@/utils/http'
// 查询新闻
const find_IndexXwzxByCplx = data => http.get(process.env.VUE_APP_BASE_GW + '/wz/find_IndexXwzxByCplx', data);

// 查询新闻详情
const get_WzDetailByIdOrXlh = data => http.get(process.env.VUE_APP_BASE_GW + '/wz/get_WzDetailByIdOrXlh', data);

// 查询新闻
const getNewsClf = data => http.get(process.env.VUE_APP_BASE_GW + '/wz/find_IndexXwzxByCplx_clfzj', data);
const getNewsWxzj = data => http.get(process.env.VUE_APP_BASE_GW + '/wz/find_IndexXwzxByCplx_wxzj', data);
const getNewsYljr = data => http.get(process.env.VUE_APP_BASE_GW + '/wz/find_IndexXwzxByCplx_yljr', data);
const getNewsYszj = data => http.get(process.env.VUE_APP_BASE_GW + '/wz/find_IndexXwzxByCplx_yszj', data);
const getNewsXyh = data => http.get(process.env.VUE_APP_BASE_GW + '/wz/find_IndexXwzxByCplx_xyh', data);
const getNewsZhgz = data => http.get(process.env.VUE_APP_BASE_GW + '/wz/find_IndexXwzxByCplx_zhgz', data);

//  获取地图数据 已在本地写死了
// 获取返校案例数据
const find_WzFxalxx = (data) => http.get(process.env.VUE_APP_BASE_GW + '/wz/find_WzFxalxx', data)
export {
  find_IndexXwzxByCplx,
  get_WzDetailByIdOrXlh,
  find_WzFxalxx,
  getNewsClf,
  getNewsWxzj,
  getNewsYljr,
  getNewsYszj,
  getNewsXyh,
  getNewsZhgz
}
